var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8088,
    cy: 32.8088,
    r: 31.5588,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5402 22.5412L26.1732 31.83C26.3292 31.955 26.3292 32.1847 26.1732 32.3082L14.5402 41.5969C14.3268 41.7673 14.0001 41.6235 14.0001 41.3578V22.7803C14.0001 22.5146 14.3251 22.3709 14.5402 22.5412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.377 21C49.684 21 49.8235 21.3641 49.5888 21.5516L33.1363 34.6878C33.1084 34.7097 33.0641 34.7097 33.0362 34.6878L16.5838 21.5516C16.349 21.3641 16.4886 21 16.7955 21H49.3787H49.377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4601 41.5969L39.827 32.3082C39.6711 32.1832 39.6711 31.9534 39.827 31.83L51.4601 22.5412C51.6735 22.3709 52.0001 22.5146 52.0001 22.7803V41.3563C52.0001 41.6219 51.6751 41.7657 51.4601 41.5954V41.5969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1593 33.6034L50.4916 43.4485C50.7264 43.636 50.5868 44.0002 50.2799 44.0002H15.7204C15.4135 44.0002 15.2739 43.636 15.5087 43.4485L27.841 33.6034C27.9625 33.5065 28.1414 33.5065 28.2629 33.6034L32.3304 36.8507C32.6998 37.1445 33.2989 37.1477 33.6617 36.8586L37.7374 33.605C37.8589 33.5081 38.0378 33.5081 38.1593 33.605V33.6034Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 23,
    fill: "white",
    transform: "translate(14 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailIcon);
export default __webpack_public_path__ + "static/media/e-mail-icon.8b1177fa20e288d71d5622473f3728a3.svg";
export { ForwardRef as ReactComponent };